module.exports = __webpack_public_path__ + "img/Diploma 02.88f162ef.png";